module.exports = __webpack_public_path__ + "side-743d3ebba2f56b02a0e4ebc2765570a7.png";